app.service('productDetailPromotions', function (_, modal, productCardConfig, store, productPromotionsListModal) {

	let $self;
	let config;

	function init() {
		config = productCardConfig.getData();
		setElements();

		setCmsPromotionBlock();
		setEvents();
	}

	function setElements() {
		$self = $('#product-promotions');
	}

	function setEvents() {
		$self.on('click', '.js-more-promotions', openPromotionsModal);
		$self.on('click', '.promotion-item', function() {
			UA.interaction('KP_Crossell', 'Sekcja_promocyjna_' + _.escapeDiacritics($(this).find('.title').text()).trim()
			.split(' ').join('_'), 'Klikniecie');
		})
		store.onChange(setCmsPromotionBlock);
	}

	function openPromotionsModal() {
		productPromotionsListModal.show(
			config.id,
			store.data.isOutlet ? store.data.outletCategoryId : undefined
		);
		UA.interaction('KP_Crossell', 'Sekcja_promocyjna_wiecej', 'Klikniecie');
	}

	function isPromotionAvailableForState() {
		return store.data.isOutlet ? config.outletPromotionAvailable : config.productPromotionAvailable;
	}

	function fetchCmsPromotions() {
		return $.ajax({
			url: '/web-cached/cms-promotion-block-section.ltr',
			data: {
				productId: config.id,
				outletCategoryId: store.data.isOutlet ? store.data.outletCategoryId : undefined
			}
		});
	}

	function setCmsPromotionBlock() {
		if (!isPromotionAvailableForState()) {
			$self.empty();
			return;
		}

		$self.addClass('loading');

		fetchCmsPromotions().then(function (html) {
			renderCmsPromotionsBlock(html);
		}).fail(function () {
			modal.alert("[Promocje CMS] Błąd pobierania.");
		}).always(function () {
			$self.removeClass('loading');
		});
	}

	function renderCmsPromotionsBlock(html) {
		$self.html(html);
	}

	return {
		init: init
	};
});